import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { DetectionConfigurationLoadedEntry, RolodexEntryType } from 'types'

export const useDetectionConfigurations = () => {
  const { data: detectionConfigurations, ...rest } =
    useGetRolodexEntriesByLoadOptions<DetectionConfigurationLoadedEntry[]>({
      type: [RolodexEntryType.DETECTION_CONFIGURATION],
      tags: {},
      limit: 1000,
    })

  return {
    detectionConfigurations: detectionConfigurations ?? [],
    ...rest,
  }
}
